import api from './api';
import { CommonArea, CommonAreaListResponse } from '../types/commonArea';

export const commonAreaService = {
  getAll: async (
    workspaceId: string,
    params?: {
      page?: number;
      limit?: number;
      sortBy?: string;
      sortOrder?: 'asc' | 'desc';
      projectId?: string;
      builderId?: string;
      areaType?: string;
      status?: string;
      search?: string;
    }
  ): Promise<CommonAreaListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/common-areas`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, commonAreaId: string): Promise<{ commonArea: CommonArea }> => {
    const response = await api.get(`/workspaces/${workspaceId}/common-areas/${commonAreaId}`);
    return response.data;
  },

  create: async (workspaceId: string, data: Partial<CommonArea>): Promise<{ commonArea: CommonArea }> => {
    const response = await api.post(`/workspaces/${workspaceId}/common-areas`, data);
    return response.data;
  },

  update: async (workspaceId: string, commonAreaId: string, data: Partial<CommonArea>): Promise<{ commonArea: CommonArea }> => {
    const response = await api.put(`/workspaces/${workspaceId}/common-areas/${commonAreaId}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, commonAreaId: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/common-areas/${commonAreaId}`);
  },

  getByProject: async (workspaceId: string, projectId: string): Promise<CommonAreaListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/common-areas`, {
      params: { projectId, limit: 1000 }
    });
    return response.data;
  }
};
